import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ParametroLista } from '../../data-visualization/reports/models/parametro';
import { environment } from 'src/environments/environment';
import { PageableService } from 'src/app/shared/services/pageable.service';
import { Paginator } from 'src/app/shared/models/paginator';
import { TableHeader } from 'src/app/shared/models/table';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ParameterListService {

  constructor(private http: HttpClient, private pageableService: PageableService) { }
  /**
  * Gets the list of parameters by page
  * It can get some params in order to filter or sort the data
  * @param {number} page
  * @param {string} header
  * @param {string} filter
  * @param {string} order
  * @returns {Observable<ParametroLista[]>}
  */
  getParametersList(page: number, pageQuantity: number, header?: string, filter?: string, order?: string): Observable<Paginator<ParametroLista>> {
    return this.pageableService.getData<ParametroLista>(`${environment.urlBase}/parametro-lista/`, page, pageQuantity, header, filter, order);
  }

  /**
   * Gets all the list of parameters by user sending filters
   * @param {BehaviorSubject} search$
   * @param {number} page
   * @returns {Observable<Paginator<ParametroLista>>}
   */
  getParamListByFilters(search$: BehaviorSubject<TableHeader | undefined>, page: number, pageQuantity: number): Observable<Paginator<ParametroLista>> {
    return this.pageableService.searchData<ParametroLista>(search$, page, pageQuantity, `${environment.urlBase}/parametro-lista/`);
  }

  /**
   * Gets all parameter list sources
   * @returns { Observable<string[]>}
   */
  getParameterSources(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.urlBase}/parametro-lista/bigquery/origenes`)
  }

  /** 
  * Creates a parameter list
  * @param {ParametroLista} param
  * @returns {Observable<ParametroLista>}
  */
  createParameterList(param: ParametroLista): Observable<ParametroLista> {
    return this.http.post<ParametroLista>(`${environment.urlBase}/parametro-lista/`, param);
  }

  /** 
  * Updates a parameter list
  * @param {ParametroLista} param
  * @returns {Observable<ParametroLista>}
  */
  updateParameterList(param: ParametroLista): Observable<ParametroLista> {
    return this.http.put<ParametroLista>(`${environment.urlBase}/parametro-lista/`, param);
  }

}